import {
  AccountStatusEnum,
  IAccountRespSchema,
  MCustomSelectProps,
} from '@monetize/types/app';
import React, { useMemo } from 'react';
import { renderItemContentForAccount } from '../../routes/Settings/rules-v3/rules.utils';
import { MainSearchInput } from '../Monetize/MCustomSelect/components/MainSearchInput';
import { MCustomSelect } from '../Monetize/MCustomSelect/MCustomSelect';

interface AccountSelectProps extends MCustomSelectProps {
  onClearAccountValue?: () => void;
  onChange: (account: IAccountRespSchema) => void;
  disabledIds?: string[];
}

export const AccountSelect = React.forwardRef<any, AccountSelectProps>(
  (
    { onClearAccountValue, onChange, disabledIds, ...rest }: AccountSelectProps,
    ref,
  ) => {
    const additionalSearchParams = useMemo(
      () => ({ status: AccountStatusEnum.ACTIVE }),
      [],
    );

    return (
      <MCustomSelect
        ref={ref}
        clearable
        onClear={onClearAccountValue}
        endpoint="/api/accounts"
        additionalSearchParams={additionalSearchParams}
        itemTitle="accountName"
        itemValue="id"
        disabledItems={disabledIds}
        getByIdEndpointFn={(recordId) => `/api/accounts/${recordId}`}
        returnItem
        infiniteScrolling
        useMainInputAsSearchInput
        MainInputComponent={MainSearchInput}
        renderItemContent={renderItemContentForAccount}
        onChange={onChange}
        isSelectOpen={false}
        {...rest}
      />
    );
  },
);
